import { makeStyles } from '@material-ui/core';

export const styles = (theme) => ({
  modalTitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#313D44',
    marginLeft: 16
  },
  textField: {
    fontFamily: 'Roboto-Regular',
    fontSize:18,
    color: '#4D4F5C',
    width: '100%'
  },
  controlSection: {
    '& > div': {
      padding: '0 16px'
    }
  },
  modalActions: {
    marginTop: 15,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  actionButton: {
    boxShadow: 'none',
    borderRadius: 2,
    textTransform: 'none',
    fontFamily: 'Roboto-Medium',
    fontSize: 16,
    marginLeft: 20
  },
  inputLableRoot: {
    color: '#313D44',
    fontFamily: 'Roboto-Bold',
    fontSize: 14
  },
  inputLabelShrink: {
    transform: 'translate(0, 1.5px) scale(1)'
  },
  inputAdornment: {
    fontSize: 14,
    color: '#ABB6BE'
  },
});

export default makeStyles(styles);